import React, {useState} from 'react';
import ActionFormLayout from '../../../../../../components/layouts/actions/ActionFormLayouts';
import './PenaltyResultPage.css';
import { List } from 'antd-mobile';
import PickerInput from '../../../../../../components/customForm/picker/PickerInput';
import Title from '../../../../../../components/Title';
import NumberInput from '../../../../../../components/customForm/number/NumberInput';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams, useHistory } from 'react-router-dom';
import { addAction, edit as editLive } from '../../../../../../services/live';
import { addActionLive, editActionLive, score as teamScore } from '../../../../../../actions/liveDataActions';
import _ from 'lodash';
import { addScore, substractScore } from '../../../../../../helpers';
import { removeAction } from '../../../../../../services/action';
import { deleteActionLive } from '../../../../../../actions/liveDataActions';
import { deleteActionLive as removeActionLive } from '../../../../../../actions/matchDataActions';
import { editAction } from '../../../../../../services/action';


const PenaltyResultPage = props => {
    const access = props.connexionReducer;
    const {id} = useParams();
    const history = useHistory();
    const qs = queryString.parse(props.history.location.search);
    const dataEdited = qs.action_edit ? JSON.parse(qs.action_edit) : null;
    const [result, setResult] = useState(dataEdited ? dataEdited.data.result : 'marque');
    const [player, setPlayer] = useState(dataEdited ? dataEdited.data.player : null);
    const arrayResult = [
        {label: 'Marqué', value: 'marque'},
        {label: 'Arrêté', value: 'arrete'},
        {label: 'Manqué', value: 'manque'}
    ];

    const settings = qs.settings ? JSON.parse(qs.settings) : {};
    const editId = dataEdited ? dataEdited['@id'] : '';
    const score = !_.isEmpty(settings) ? settings.score : (qs.score ? JSON.parse(qs.score) : {home: null, away: null});
    const prevAction = !_.isEmpty(settings) ? settings.prevAction : (qs.prevAction ? JSON.parse(qs.prevAction) : (dataEdited ? dataEdited.data.relatedAction : {}));
    const isNotFromStepOne = _.isEmpty(settings) && _.isEmpty(qs.prevAction);
    const category = !_.isEmpty(settings) ? settings.category : (!_.isEmpty(prevAction) ? prevAction.data.category : (dataEdited ? dataEdited.data.category : ''));
    const prevCategory = dataEdited ? dataEdited.data.relatedAction.data.category : category;
    const prevResult = dataEdited ? dataEdited.data.result : result;
    const slug = 'penalty_resultat';
    const teamName = !_.isEmpty(settings) ? settings.teamName : (!_.isEmpty(prevAction) ? prevAction.teamName : (dataEdited ? dataEdited.teamName : ''));
    const actionId = !_.isEmpty(settings) ? settings.penaltyResultSettings['@id'] : (dataEdited ? dataEdited.type['@id'] : '');
    const team = !_.isEmpty(settings) ? settings.teamId : (!_.isEmpty(prevAction) ? prevAction.teamId : (dataEdited ? dataEdited.teamId : ''));
    const minute = !_.isEmpty(settings) ? settings.minute : (!_.isEmpty(prevAction) ? prevAction.minute : (dataEdited ? dataEdited.minute : 0));
    const [showBtnSubmit, setShowBtnSubmit] = useState(true);
    const [isOnSubmit, setIsOnSubmit] = useState(false);

    return(
        <ActionFormLayout
            title='Penalty'
            submit={() => submit(id, {
                result, 
                score, 
                category, 
                slug,
                teamName,
                player,
                actionId,
                team,
                minute,
                prevCategory,
                prevResult
            }, access, editId, props.addActionLive, history, prevAction, props.editActionLive, props.teamScore, setIsOnSubmit)}
            enabled={true}
            id='result_penalty'
            style={{margin: '0 0 0 -100%', width: '100%', height: '100%'}}
            onShow={() => {
                const element = document.getElementById('result_penalty')
                element.classList.add('animated-result_penalty')
            }}
            previousStep={() => revertAction(id, access, props, prevAction, history, score, dataEdited, props.editActionLive,isNotFromStepOne, actionId)}
            showBtn={showBtnSubmit}
            isOnSubmit={isOnSubmit}
        >
            <div className='ls_debut_form' style={{marginBottom: '100px'}}>
                <List.Item multipleLine wrap>
                    <div className='common'>
                        Patientez quelques instants le temps que le joueur tire son penalty pour renseigner ces informations
                    </div>
                </List.Item>
                <List renderHeader={() => <Title text='finalité du penalty' />}>
                    <PickerInput data={arrayResult} label={'Finalité'} extra='à renseigner' value={result} onOk={setResult} />
                </List>
                <List renderHeader={() => <Title text='informations optionnelles' />}>
                    <NumberInput 
                        label='Tireur (n° maillot)' 
                        placeholder='à renseigner' 
                        min={1} 
                        max={99} 
                        value={player} 
                        defaultValue={player} 
                        onChange={setPlayer} 
                        id='ls_maillot_penalty'
                        onFocus={() => setShowBtnSubmit(false)} 
                        onBlur={() => setShowBtnSubmit(true)}
                    />
                </List>
            </div>
        </ActionFormLayout>
    )

}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({addActionLive, deleteActionLive, removeActionLive, editActionLive, teamScore}, dispatch);

const submit = (id, data, access, editId, addActionLive, history, prevAction, editActionLive, teamScore, setIsOnSubmit) => {
    setIsOnSubmit(true);
    const score = data.result === 'marque' ? (data.prevCategory === data.category ? addScore(data.score, data.category) : addScore(substractScore(data.score, data.prevCategory), data.category)) : (data.prevResult === 'marque' ? substractScore(data.score, data.prevCategory) : data.score );
    const dataPenaltyResult = {
        label: `${data.slug}-${data.result}`,
        actionName: data.result === 'marque' ? `BUT ! de ${data.teamName}` : (data.result === 'arrete' ? `Penalty arrêté de ${data.teamName}` : `Penalty manqué de ${data.teamName}`),
        description: data.player > 0 ? `Penalty du n°${data.player}` : '',
        success: data.result === 'marque',
        score,
        result: data.result,
        player: data.player,
        category: data.category,
        relatedAction: prevAction
    };
    if(editId) {
        editAction(editId, {
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            data: dataPenaltyResult,
            score
        }, access, id, data.actionId).then(response => {
            setIsOnSubmit(false);
            editAction(prevAction['@id'], {data: _.assign(prevAction.data, {relatedAction: response.data})}, access, id, data.actionId).then(r => editActionLive(id, r.data))
            teamScore(id, score);
            editLive(id, {score}, access);
            editActionLive(id, response.data);
            history.push(`/live/${id}`);
        })
    }
    else {
        addAction(id, {
            type: data.actionId,
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            data: dataPenaltyResult,
            score
        }, access).then(response => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer résultat penalty'
                }
            }), '*');
            setIsOnSubmit(false);
            editAction(prevAction['@id'], {data: _.assignIn(prevAction.data, {relatedAction: _.findLast(response.data.actions, a => a.type['@id'] === data.actionId)})}, access, id, data.actionId)
                .then(r => editActionLive(id,r.data));
            teamScore(id, score);
            addActionLive(id, response.data);
            history.push(`/live/${id}`)
        })
    }
}

const revertAction = (id, access, props, prevAction, history, score, dataEdited, editActionLive, isNotFromStepOne, actionId) => {
    if(!isNotFromStepOne) {
        try {
            if(dataEdited) {
                const dataDeclarePenalty = {
                    label: 'penalty_declaration',
                    actionName: dataEdited.data.relatedAction.data.actionName,
                    description: dataEdited.data.relatedAction.data.description,
                    sanction: dataEdited.data.relatedAction.data.sanction,
                    teamSanctioned: dataEdited.data.relatedAction.data.teamSanctioned,
                    category:dataEdited.data.relatedAction.data.category,
                    score: dataEdited.data.relatedAction.data.score
                }
                editAction(dataEdited.data.relatedAction['@id'], {
                    teamId: parseInt(dataEdited.data.relatedAction.teamId),
                    teamName: dataEdited.data.relatedAction.teamName,
                    minute: parseInt(dataEdited.data.relatedAction.minute),
                    data: dataDeclarePenalty
                }, access, id, actionId).then((response) => {
                    editActionLive(id, response.data);
                    history.push(`/live/${id}`)
                })
            }
            else {
                removeAction(prevAction['@id'], access, id).then(() => {
                    props.deleteActionLive(id, prevAction['@id']);
                    props.removeActionLive(id, prevAction['@id']);
                    const settings = {
                        penaltyResultSettings: {'@id': actionId, slug: 'penalty_resultat'}
                    }
                    history.push(`/live/${id}/penalty_declaration?action_edit=${JSON.stringify( _.omit(prevAction, '@id'))}&score=${JSON.stringify(score)}&settings=${JSON.stringify(settings)}`)
                });
            }
        } catch (error) {
            
        }
    }
    else {
        history.push(`/live/${id}`)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PenaltyResultPage);
